import Scene from '@ozoneuniverse/mfe-core/dist/components/models/scene';
import {
  baseURL2022Dragon,
  baseURL2022Global,
} from '@ozoneuniverse/mfe-core/dist/components/gltfs/urlsBase';
import * as THREE from 'three';
import {
  createGroup,
  createTexture,
} from '@ozoneuniverse/mfe-core/dist/components/gui/factory';
import { createText } from '@ozoneuniverse/mfe-core/dist/components/gui/house';

declare global {
  interface Window {
    Scene: unknown;
    baseURL2022Dragon: unknown;
    baseURL2022Global: unknown;
    createGroup: unknown;
    createTexture: unknown;
    createText: unknown;
  }
}

export default function exposeBlueprintsDependencies() {
  if (typeof window !== 'undefined') {
    window.Scene = Scene;
    window.baseURL2022Dragon = baseURL2022Dragon;
    window.baseURL2022Global = baseURL2022Global;
    window.THREE = THREE;
    window.createGroup = createGroup;
    window.createTexture = createTexture;
    window.createText = createText;
  }
}
